import { Plugins } from '@capacitor/core';
const { App } = Plugins;
import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from '../store/index'
import api from '@/api'
import axios from 'axios'

App.addListener('appUrlOpen', function (data) {
  // Example url: https://beerswift.app/tabs/tabs2
  // slug = /tabs/tabs2
  const slug = data.url.split('.com').pop();

  // We only push to the route if there is a slug present
  if (slug) {
    router.push({
      path: slug,
    });
  }
});

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    beforeEnter: logRouting,
    component: () => import('@/views/Login'),
  },
  {
    path: '/',
    name: 'Home',
    beforeEnter: authMiddleware,
    component: Home,
  },
  {
    path: '/webcam-widget',
    name: 'WidgetWebcam',
    component: ()=>import('@/views/WebcamWidget'),
  },
  {
    path: '/documents',
    name: 'DocumentView',
    beforeEnter: authMiddleware,
    component: ()=>import('@/views/Documents'),
  },
  {
    path: '/documentsnew',
    name: 'DocumentNew',
    beforeEnter: authMiddleware,
    component: ()=>import('@/views/DocumentsNew'),
  },
  {
    path: '/ville.php?id=2977281&code_pays=FR',
    redirect: '/forecasts',
    name: 'Home',
    beforeEnter: authMiddleware,
    component: () => import('@/components/Forecasts/Resum'),
  },
  {
    path: '/plans',
    name: 'Plans',
    beforeEnter: authMiddleware,
    component: () => import('@/views/Plans'),
  },
  {
    meta: {
      title: 'maps',
    },
    path: '/maps',
    name: 'Radar/Satellite',
    beforeEnter: authMiddleware,
    component: () => import('@/views/Maps'),
    children: [
      {
        path: 'weathermap',
        component: () => import('@/components/Weathermap/Weathermap'),
        beforeEnter: authMiddleware,
        meta: { rules: 'radar_precipitations' },
      },
      {
        path: 'radar',
        component: () => import('@/components/Maps/Radar'),
        beforeEnter: authMiddleware,
        meta: { rules: 'radar_precipitations' },
      },
      {
        path: 'stormwatch',
        component: () => import('@/components/Stormwatch/Map'),
        beforeEnter: authMiddleware,
        meta: { rules: 'stormwatch' },
      },
      {
        path: 'satellite',
        component: () => import('@/components/Maps/Satellite'),
      },
      {
        path: 'hail',
        component: () => import('@/components/Hail/HailMap'),
        meta: { rules: 'hail' },
      },
    ],
  },
  {
    path: '/admin',
    name: 'Admin',
    beforeEnter: authMiddleware,
    component: () => import('@/views/Admin'),
    children: [
      {
        path: '',
        component: () => import('@/components/Admin/UsersList'),
        meta: { rules: 'admin' },
      },
    ],
  },
  {
    path: '/alertes',
    component: () => import('@/views/Alerts'),
    beforeEnter: authMiddleware,
    children: [
      { path: '', component: () => import('@/components/Alertes/Setting') },
      {
        path: 'v2',
        component: () => import('@/components/Alertes/NewAlerts'),
        meta: { rules: 'alerts' },
      },
      {
        path: 'v2/list',
        component: () => import('@/components/Alertes/AlertsList'),
        meta: { rules: 'alerts' },
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login'),
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/Register'),
  },
  {
    path: '/upgrade',
    name: 'Upgrade',
    component: () => import('@/views/Upgrade'),
  },
  {
    path: '/weathermaps',
    component: () => import('@/components/Weathermap/Weathermap'),
    beforeEnter: authMiddleware,
    meta: { rules: 'weathermaps' },
  },
  {
    path: '/publicweathermaps',
    component: () => import('@/components/Weathermap/Weathermap'),
    beforeEnter: isPublicAuth,
    meta: { rules: 'weathermaps' },
  },
  {
    path: '/stations',
    component: () => import('@/views/Stations'),
    beforeEnter: authMiddleware,
    children: [
      { path: '', component: () => import('@/components/Stations/List') },
      {
        path: 'create',
        component: () => import('@/components/Stations/Create'),
      },
      {
        path: ':id_station',
        component: () => import('@/components/Stations/Data'),
      },
    ],
  },
  {
    path: '/profil',
    beforeEnter: authMiddleware,
    component: () => import('@/views/Profil'),
    children: [
      {
        path: '',
        name: 'Profil',
        component: () => import('@/components/Profil/Profil'),
      },
      {
        path: 'referrer',
        name: 'Referrer',
        component: () => import('@/components/Profil/Referrer'),
      },
      {
        path: 'stormwatch',
        name: 'Stormwatch',
        component: () => import('@/components/Admin/StormwatchAdmin'),
      },
    ],
  },
  {
    meta: {
      title: 'Forecasts',
    },
    path: '/forecasts',
    name: 'Previsions',
    beforeEnter: authMiddleware,
    component: () => import('@/views/Forecasts'),
    children: [
      {
        path: 'alerts/:geoname/:cityname',
        component: () => import('@/components/Forecasts/Alerts'),
      },
      {
        path: ':geoname/:cityname',
        component: () => import('@/components/Forecasts/Forecasts'),
        beforeEnter: authMiddleware,
        meta: { type:"monograph", rules: 'forecast_7' },
      },
      {
        path: ':geoname/:cityname/long',
        component: () => import('@/components/Forecasts/ForecastsLong'),
        beforeEnter: authMiddleware,
        meta: { rules: 'forecast_14' },
      },
      {
        path: ':geoname/:cityname/roadcast',
        component: () => import('@/components/Forecasts/Roadcast'),
        beforeEnter: authMiddleware,
        meta: { rules: 'roadcast' },
      },
      {
        path: ':geoname/:cityname/multi',
        component: () => import('@/components/Forecasts/MultiModel'),
        beforeEnter: authMiddleware,
      },
      {
        path: ':geoname/:cityname/multichart',
        component: () => import('@/components/Forecasts/ForecastMulti'),
        beforeEnter: authMiddleware,
        meta: {  },
      },
      {
        path: ':geoname/:cityname/resum',
        component: () => import('@/components/Forecasts/Resum'),
      },
    ],
  },
]

async function logRouting (to, from, next) {
  next()
  try{
	  throw new Error(to.path)
  }catch(err)
  {
	  console.log(err);
  }
}

function isPublicAuth(to, from, next) {
  console.log(to);
  return to.query.token == 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.o8-mX-tixfKG8kh-tP6zgiAbNQuSccVztGimM8MUEjU' ? next() : false; 
}

async function authMiddleware(to, from, next) {
  store.state.routerLoading = true
  if (store.state.token !== null) {
    axios.defaults.headers.common = {
      Authorization: `Bearer ${store.state.token}`,
    }
    try {
      if (!store.state.user) {
        store.state.mainloading = true
        let { user } = await api.users.me(store.state.token)
        let userdata = await api.users.get(user.id_user)
        let alerts = await api.alert.get(user.id_user)
        store.state.mainloading = false
        store.dispatch('setUser', userdata)
        store.dispatch('setAlerts', alerts)
      }
      if (to.meta.rules) {
        if (store.state.user.features.find((map) => map == to.meta.rules)) {
          next()
          window.mt('send', 'pageview', {email: store.state.user.user_email, firstname: `${store.state.user.user_prenom} ${store.state.user.user_nom}`})
        } else {
          next('/plans')
        }
      } else {
        next()
        window.mt('send', 'pageview', {email: store.state.user.user_email, firstname: `${store.state.user.user_prenom} ${store.state.user.user_nom}`})
      }
    } catch (err) {
      console.log(err)
      store.state.mainloading = false
      next(`/login`)
    }
  } else {
    if(to.path)
    {
      next({name:'Login', query:{redirect:to.path.split('/')[1]}})
    }else{
      next({name:'Login'})
    }
  }

  store.state.routerLoading = false
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next)=>{
  setTimeout(()=>{
    try{
      // window.mt('send', 'pageview', {email: store.state.user.user_email, firstname: `${store.state.user.user_prenom} ${store.state.user.user_nom}`})
      console.log('tests');
    }catch(err)
    {
      console.log(err);
    }
  }, 5000)
  next();
})

export default router
